import React from 'react';

const faqs = [
  {
    question: "SolarTools nedir?",
    answer: "SolarTools, güneş enerjisi sistemlerinin izlenmesi ve yönetimi için geliştirilmiş bir IoT platformudur. Enerji üretimi, tüketimi ve sistem performansını gerçek zamanlı olarak takip etmenizi sağlar."
  },
  {
    question: "Hangi cihazlar destekleniyor?",
    answer: "SolarTools, çoğu inverter markası ve enerji analizörü ile uyumludur. Desteklenen cihazların tam listesi için lütfen teknik dokümantasyona bakın."
  },
  {
    question: "Veriler ne sıklıkla güncellenir?",
    answer: "Veriler varsayılan olarak 5 dakikada bir güncellenir. Bu süre, ihtiyaçlarınıza göre 1 dakikaya kadar düşürülebilir veya daha uzun aralıklara ayarlanabilir."
  },
  {
    question: "Veri depolama süresi ne kadardır?",
    answer: "Ücretsiz planda 30 günlük veri depolama sunuyoruz. Premium planlarda bu süre 1 yıla kadar çıkabilmektedir."
  },
  {
    question: "API erişimi mevcut mu?",
    answer: "Evet, tüm planlarımızda REST API erişimi sunuyoruz. API dokümantasyonumuza Developers bölümünden ulaşabilirsiniz."
  }
];

export default function FAQ() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-[var(--color-primary)] mb-8">
        Sıkça Sorulan Sorular
      </h1>

      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div 
            key={index}
            className="bg-white rounded-lg shadow-md p-6"
          >
            <h3 className="text-xl font-semibold text-[var(--color-primary)] mb-3">
              {faq.question}
            </h3>
            <p className="text-[var(--color-black)]">
              {faq.answer}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-[var(--color-background)] rounded-lg p-6 text-center">
        <h3 className="text-xl font-semibold text-[var(--color-primary)] mb-4">
          Sorunuz hala cevaplanmadı mı?
        </h3>
        <p className="text-[var(--color-black)] mb-4">
          Teknik destek ekibimiz size yardımcı olmaktan mutluluk duyacaktır.
        </p>
        <a
          href="/contact"
          className="inline-block bg-[var(--color-primary)] text-white px-6 py-2 rounded-lg hover:bg-[var(--color-secondary)] transition-colors"
        >
          Bize Ulaşın
        </a>
      </div>
    </div>
  );
} 